import {
  Box,
  FormControlLabel,
  FormGroup,
  // Switch,
  TextField,
} from "@mui/material";
import { Switch } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/Save";
import { getAllJobs, setBackendJobs } from "../../../Utils/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import cogoToast from "cogo-toast";

function TemplateServer() {
  const { resourcesData } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const location = useLocation();
  const [form, setForm] = useState({
    host: "",
    port: "",
    secure: "",
    userName: "",
    password: "",
  });
  const [error, setError] = useState({
    host: "",
    port: "",
    secure: "",
    userName: "",
    password: "",
  });

  const [templateForm, setTemplateForm] = useState({
    templateManager: "Y",
    templateManagerTime: 0,
  });
  const [templateError, setTemplateError] = useState({
    templateManager: "",
    templateManagerTime: "",
  });

  const handleChange = (e) => {
    if(e.target.name === 'secure') {
      setError({ ...error, [e.target.name]: "" });
      setForm({ ...form, [e.target.name]: e.target.value === "Y" ? "N" : "Y" });
    } else {
      setError({ ...error, [e.target.name]: "" });
      setForm({ ...form, [e.target.name]: e.target.value.toString() });

      setTemplateError({ ...templateError, [e.target.name]: "" });
      setTemplateForm({
        ...templateForm,
        [e.target.name]: e.target.value.toString(),
      });
    }
  };

  const apiCall = () => {
    dispatch(getAllJobs());
  };

  useEffect(() => {
    if (
      location.pathname === "/configForm" ||
      location.pathname === "/appConfig"
    ) {
      apiCall();
    }
  }, []);

  useEffect(() => {
    if (Object.keys(resourcesData).length > 0) {
      setTemplateForm({
        ...templateForm,
        ...resourcesData,
        templateManager: "Y",
      });
      setForm({
        ...resourcesData
      })
    }
  }, [resourcesData]);

  const handleCheckChange = (e) => {
    setTemplateError({ ...templateError, [e.target.name]: "" });
    setTemplateForm({
      ...templateForm,
      [e.target.name]: e.target.value === "Y" ? "N" : "Y",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (form.host.trim() === "") {
      setError({ ...error, host: "Host is required" });
      return;
    }
    if (form.port.trim() === "") {
      setError({ ...error, port: "Port is required" });
      return;
    }
    if (form.userName.trim() === "") {
      setError({ ...error, userName: "User Name is required" });
    }
    if (form.password.trim() === "") {
      setError({ ...error, password: "Password is required" });
    }
    if (
      setTemplateForm.templateManager === "Y" &&
      !setTemplateForm.templateManagerTime
    ) {
      setTemplateError({
        ...error,
        templateManagerTime: "Template Manager Time is required",
      });
      return;
    }

    console.log("form===>>>>", form);
    try {
      // if (templateForm.templateManagerTime) {
      //   dispatch(setBackendJobs(templateForm.templateManagerTime));
      // }
      const data = {
        host: form.host,
        port: form.port,
        secure: form.secure,
        userName: form.userName,
        password: form.password,
        ...templateForm
        // templateManager: templateForm.templateManager,
        // templateManagerTime: templateForm.templateManagerTime,
      };
      dispatch(setBackendJobs(data));
      // if (location.pathname === "/validForm") {
      //   setTabs(1);
      // } else {
      //   apiCall();
      // }
    } catch (err) {
      cogoToast.error("Not successful");
    }

    setForm({
      host: "",
      port: "",
      secure: "",
      userName: "",
      password: "",
    });
  };

  const textFields = { margin: "5px", padding: "10px", height: "70px" };
  const textFld = { margin: "5px", padding: "0px", display: "flex",flex: '0 0 200px' };
  const textFld1 = { margin: "5px", padding: "0px", display: "flex" };
  const switchtextFld = { marginLeft: "10px", display: "block" };

  const handleSetting = (e) => {
    let value = e.target.value === "0" ? "" : e.target.value;
    setForm({ ...form, [e.target.name]: value });
    setTemplateForm({ ...templateForm, [e.target.name]: value });
  };

  return (
    <Fragment>
      <Card className="shadow-none" style={{ height: "83vh" }}>
        <Card.Body>
          <div className="col-md-12">
            <Box
              component="form"
              className="addUserBox"
              onSubmit={handleSubmit}
              noValidate
              autoComplete="off"
            >
              <div className="col-md-12 d-flex" style={textFields}>
              <div style={{switchtextFld, flex: '0 0 200px'}}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch style={{ color: "#286685" }} />}
                      name="templateManager"
                      onChange={handleCheckChange}
                      value={templateForm.templateManager}
                      checked={templateForm.templateManager === "Y"}
                      label="Template Manager"
                    />
                  </FormGroup>
                </div>
                {templateForm.templateManager === "Y" ? (
                  <div className="row" style={{marginLeft:"20px"}}>
                    <div className="" style={{...textFld1}}>
                      <TextField
                        type="number"
                        name="templateManagerTime"
                        onFocus={handleSetting}
                        label="Sync time"
                        value={templateForm.templateManagerTime}
                        required
                        onChange={handleChange}
                        error={!!templateError.templateManagerTime}
                        helperText={templateError.templateManagerTime}
                      />
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="textBoxes d-block">
                <div className="col-md-12 " style={textFields}>
                  <div className="row">
                    <div className="col-md-4 mt-0" style={textFld}>
                      <TextField
                        type="text"
                        name="host"
                        label="Host"
                        value={form.host}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.host}
                        helperText={error.host}
                      />
                    </div>
                    <div style={{textFld, marginLeft: "20px"}}>
                      <TextField
                        type="number"
                        name="port"
                        label="Port"
                        value={form.port}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.port}
                        helperText={error.port}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div style={{textFld, marginTop: "10px", marginBottom: "10px"}}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Switch
                              // name="secure"
                              // checked={form.secure === "Y"}
                              // onChange={handleChange}
                            />
                          }
                          label="Secure"
                          name="secure"
                          onChange={handleChange}
                          value={form.secure}
                          checked={form.secure === "Y"}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4 mt-0" style={textFld}>
                      <TextField
                        type="text"
                        name="userName"
                        label="User Name"
                        value={form.userName}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.userName}
                        helperText={error.userName}
                      />
                    </div>
                    <div style={{textFld, marginLeft: "20px"}}>
                      <TextField
                        type="password"
                        name="password"
                        label="Password"
                        value={form.password}
                        onFocus={handleSetting}
                        onChange={handleChange}
                        required
                        error={!!error.password}
                        helperText={error.password}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <Button
                      type="submit"
                      startIcon={<SaveIcon />}
                      style={{
                        backgroundColor: "#286685",
                        color: "#fff",
                        width: "100px",
                        left: "40px",
                        marginTop: "20px",
                      }}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
}

export default TemplateServer;
